import React, { useState } from "react";
import { useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { DisplayMsg } from "../../../../../services/toastService";
import { updateMerchantId } from "../../../../../api/payrixApi";

const PayrixSetting = () => {
  const sharedData = useSelector((state) => state.SharedLayoutData);

  const apiKey = sharedData?.clientApiKey;
  const token = sessionStorage.getItem("userToken");

  const [merchantEntityId, setMerchantEntityId] = useState("");
  const [publicApiKey, setPublicApiKey] = useState("");
  const [privateApiKey, setPrivateApiKey] = useState("");

  const {
    getValues,
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    defaultValues: {
      merchantId: "",
    },
  });

  const onSubmit = async (data) => {
    if (!apiKey || !token) {
      console.error("Missing required data: apiKey, or token.");
      DisplayMsg(
        "2",
        `Missing required data to update Merchant ID. ${
          !apiKey ? "API Key is missing. " : ""
        }${!token ? "User token is missing." : ""}`
      );
      return;
    }

    const response = await updateMerchantId(token, apiKey, data.merchantId);

    console.log(response);

    if (response?.succeeded) {
      DisplayMsg("1", "Merchant ID updated successfully.");
      setMerchantEntityId(response?.data?.merchantEntityId || "");
      setPublicApiKey(response?.data?.publicApiKey || "");
      setPrivateApiKey(response?.data?.privateApiKey || "");
    } else {
      DisplayMsg("2", `Failed to update Merchant ID. ${response?.message}`);
    }
  };

  const copyPayrixValues = () => {
    // Generate a json
    const payrixDetails = {
      merchantId: getValues("merchantId"),
      merchantEntityId,
      publicApiKey,
      privateApiKey,
    };

    // Copy to clipboard
    navigator.clipboard
      .writeText(JSON.stringify(payrixDetails, null, 2))
      .then(() => {
        DisplayMsg("1", "Payrix details copied to clipboard.");
      })
      .catch((err) => {
        DisplayMsg("2", `Failed to copy Payrix details. ${err}`);
      });
  };

  return (
    <>
      <div className="row table-panel-header mt-4 bg-white">
        <div className="col-md-12">
          <h6>
            Payrix Setting <span className="text-lg text-red-500">*</span>
          </h6>
        </div>
      </div>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="row">
          <div className="col-md-12 col-sm-12">
            <div className="field-container">
              <label
                htmlFor="merchantId"
                className="field-placeholder font-medium"
              >
                Merchant Id
                <span className="redboxRequired" />{" "}
              </label>
              <input
                type="text"
                id="merchantId"
                className="field-input"
                {...register("merchantId", {
                  required: "Merchant ID is required",
                })}
                readOnly={
                  !!merchantEntityId && !!publicApiKey && !!privateApiKey
                }
              />
            </div>
            {merchantEntityId && (
              <div className="field-container">
                <label
                  htmlFor="merchantEntityId"
                  className="field-placeholder font-medium"
                >
                  Merchant Entity Id{" "}
                </label>
                <input
                  type="text"
                  id="merchantEntityId"
                  className="field-input"
                  value={merchantEntityId}
                  readOnly
                />
              </div>
            )}
            {publicApiKey && (
              <div className="field-container">
                <label
                  htmlFor="publicApiKey"
                  className="field-placeholder font-medium"
                >
                  Public Api Key{" "}
                </label>
                <input
                  type="text"
                  id="publicApiKey"
                  className="field-input"
                  value={publicApiKey}
                  readOnly
                />
              </div>
            )}
            {privateApiKey && (
              <div className="field-container">
                <label
                  htmlFor="privateApiKey"
                  className="field-placeholder font-medium"
                >
                  Private Api Key{" "}
                </label>
                <input
                  type="text"
                  id="privateApiKey"
                  className="field-input"
                  value={privateApiKey}
                  readOnly
                />
              </div>
            )}
            {errors.merchantId && (
              <span className="requiredtext">{errors.merchantId.message}</span>
            )}
            <div className="row justify-content-center">
              <div className="text-center">
                {!merchantEntityId || !publicApiKey || !privateApiKey ? (
                  <input
                    type="submit"
                    className="btnLinkGreen btnUpdate"
                    value="Create"
                  />
                ) : null}
                {merchantEntityId || publicApiKey || privateApiKey ? (
                  <input
                    type="button"
                    className="btnLinkBlue btnUpdate"
                    value="Copy Details"
                    onClick={copyPayrixValues}
                  />
                ) : null}
              </div>
            </div>
          </div>
        </div>
      </form>
    </>
  );
};

export default PayrixSetting;
